import React, { useState } from 'react';

import { useQueryGetNotifications } from 'api/queries/getNotifications.query';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';

import NotificationGroup from 'components/App/AuthenticateLayout/Header/Notification/NotificationGroup/NotificationGroup';
import { IGetNotificationsResponse } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.types';
import { groupNotificationsByDate } from 'components/App/AuthenticateLayout/Header/Notification/Notifications.utils';
import { Switch } from 'components/DesignSystem/Switch';

import classes from './notifications.mobile.module.scss';

export const Notifications = () => {
    const [showUnread, setShowUnread] = useState(false);
    const { isLoading, data: notifications } = useQueryGetNotifications();
    const filteredList = showUnread ? notifications?.filter((item) => !item.isRead) : notifications;
    const grouped = filteredList ? groupNotificationsByDate<IGetNotificationsResponse>({ list: filteredList }) : [];
    const title = `My Notifications (${filteredList?.length ?? 0})`;

    const handleShowUnread = () => {
        setShowUnread(!showUnread);
    };

    return (
        <WidgetWithTitle
            className={classes.notificationWidget}
            title={title}
            titleComponents={[
                <div key={'readUnread'} className={classes.item}>
                    <Switch
                        checked={showUnread}
                        onChange={handleShowUnread}
                        label={'Only show unread'}
                        labelPlacement={'start'}
                    />
                </div>,
            ]}
        >
            <div className={classes.notificationList}>
                {isLoading && <OverlayWithSpinner />}

                <div className={classes.list}>
                    {grouped.length === 0 && (
                        <div className={classes.emptyList}>
                            <MuiIcon icon={'message'} fontSize={'9rem'} color={'#9c9c9c'} />
                            No notifications yet...
                        </div>
                    )}
                    {grouped.map((group) => (
                        <NotificationGroup key={group.title} group={group} />
                    ))}
                </div>
            </div>
        </WidgetWithTitle>
    );
};
